export default __webpack_public_path__ + "static/media/trophy.6b5692fc.png";